export const SEXUAL_ORIENTATION_MODEL = "sexual-orientation";

const sexualOrientationModel = {
  name: ""
};

export default sexualOrientationModel;
